// Helper functions for getting values from state

import { STATUS } from '@/constants'
import _get from 'lodash/get'

export default {
  // Our application model (window.MODEL) is not a good match for Vue
  // reactivity because of its mix of data, metadata and business logic.
  // However it is useful for it to be universally accessible via a getter.
  // To make this work we simply reference state.application (which is reactive)
  // before returning our model.
  model: state => (state.renderModel ? window.MODEL : []),
  referenceData: state => dataset => {
    // Returns reference data (droplist data) for a specified category
    try {
    if (typeof dataset === 'function') {
        // If 'dataset' attribute is a function, run function (passing in application data) to get dataset name...
        dataset = dataset(state.application)
      }
      return state.referenceData[dataset] || []
    } catch (e) {
      return []
    }
  },

  lookupCode: (state, getters) => (dataset, code) => {
    // Looks up reference data text based on supplied dataset name and item code
    if (code === null || code === undefined) {
      return ''
    }
    let item = getters.referenceData(dataset).find(data => data.value === code)
    if (item) {
      return item.text + (item.hidden ? ' (SUSPENDED)' : '')
    }
    return code ? `${code} (description unavailable)` : ''
  },

  application: state => state.application,

  isEditing: state => state.isEditing,

  isPrintPreview: state => state.isPrintPreview,

  isSpinner: state => state.showSpinner,

  isApproved: state =>
    state.application && state.application.applicationStatus === STATUS.APPROVED,

  isWithdrawn: state =>
    state.application &&
    state.application.applicationStatus === STATUS.WITHDRAWN,

  isDeclined: state =>
    state.application &&
    state.application.applicationStatus ===STATUS.DECLINED,


  focusFieldId: state => state.focusFieldId,

  totalAlerts: (state, getters) =>
    getters.missingFields.length +
    getters.invalidFields.length +
    getters.conflictFields.length +
    getters.unresolvedMatching.length +
    (getters.isCheckForSrn ? 1 : 0),

  isCheckForSrn: state => !state.ernRecord,

  missingFields: (state, getters) =>
    getters.model.filter(
      row => row.isMissing || (row.isWarning && !row.isResolved)
    ),

  invalidFields: (state, getters) => getters.model.filter(row => row.isInvalid),

  conflictFields: (state, getters) =>
    getters.model.filter(row => row.isConflict),

  unresolvedMatching: (state, getters) =>
    getters.model.filter(row => row.isUnresolvedMatching),


  totalSupportingDocs: state => {
    if (state.application && state.application.supportingDocuments) {
      let totalDocs = Object.values(state.application.supportingDocuments)
      let totalDocsNum = totalDocs.reduce((acc, cur) => {
        return acc + cur.length
      }, 0)
      return totalDocsNum
    } else {
      return 0
    }
  },

  userID: state => state.userID,
  userName: state => state.userName,
  selectedCategory: state =>
    state.category ? state.category : 'New',
  filteredApplicationIds: state => state.filteredApplicationIds,  
}
